import { Injectable } from '@angular/core';
import { fromEvent, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MouseService {
  private readonly THRESHOLD = 600000;
  mouseMove$ = fromEvent(document, 'mousemove');

  constructor() {}

  detectMouseFreeze() {
    return this.mouseMove$.pipe(
      switchMap(() => timer(this.THRESHOLD)),
      map(() => true)
    );
  }
}